import { Component, OnInit, Optional } from "@angular/core";
import { Router } from "@angular/router";
import { NbDialogRef, NbToastrService } from "@nebular/theme";
import { CrowdsaleHelperService } from "../services/crowdsale-helper.service";

@Component({
    selector: "ngx-add-crowdsale",
    templateUrl: "./add-crowdsale.component.html",
    styleUrls: ["./add-crowdsale.component.scss"],
})
export class AddCrowdsaleComponent implements OnInit {
    public contractAddress: string;
    constructor(
        private _crowdsaleHelperService: CrowdsaleHelperService,
        private _router: Router,
        private _toastr: NbToastrService,
        @Optional() private _thisDialog: NbDialogRef<AddCrowdsaleComponent>
    ) {}

    ngOnInit(): void {}

    onSaveCrowdsale() {
        let savedCrowdsales: any = localStorage.getItem("myCrowdsales");
        let isSaved: boolean = false;
        if (savedCrowdsales) {
            JSON.parse(savedCrowdsales).forEach((crowdsale) => {
                if (crowdsale.contractAddress == this.contractAddress) {
                    this._toastr.warning(
                        "This crowdsale is already saved.",
                        "Unable to save the crowdsale!"
                    );
                    isSaved = true;
                }
            });
        }

        if (!isSaved) {
            this._toastr.success(
                "If the crowdsale exists, it will be saved.",
                "You will be redirected to the crowdsale!",
                { duration: 3000 }
            );
            setTimeout(() => {
                this._thisDialog.close();
                this._router.navigate([this.contractAddress.trim()]);
            }, 3000);
        }
    }
}
